import React from 'react';
function More({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M13 12a1 1 0 10-2 0 1 1 0 002 0zM13 18a1 1 0 10-2 0 1 1 0 002 0zM13 6a1 1 0 10-2 0 1 1 0 002 0z" />
    </svg>
  );
}

export default More;
